import api from './client';

export interface Invitation {
  id: string;
  email: string;
  role: string;
  organization_id: string | null;
  token: string;
  expires_at: string;
  accepted_at: string | null;
  created_at: string;
}

export async function createInvitation(data: {
  email: string;
  role: string;
  organization_id?: string | null;
}) {
  const res = await api.post<Invitation>('/invitations', data);
  return res.data;
}

export async function listInvitations() {
  const res = await api.get<Invitation[]>('/invitations');
  return res.data;
}

export async function revokeInvitation(id: string) {
  const res = await api.delete(`/invitations/${id}`);
  return res.data;
}

export async function acceptInvitation(data: {
  token: string;
  full_name: string;
  password: string;
}) {
  const res = await api.post('/auth/accept-invite', data);
  return res.data;
}
